/**
 * Helpers Capacitor centralisés. Évite la duplication du check isNativeApp()
 * dans chaque page qui doit empêcher des fallbacks navigateur (window.open,
 * window.print, blob download forcé) qui crashent le WebView Android.
 *
 * Pourquoi `window.open` crash le WebView Capacitor :
 *  - WebView Android ≠ navigateur Chrome — pas de barre d'onglets, pas de
 *    notion de "nouvelle fenêtre".
 *  - `window.open('', '_blank', ...)` tente une intent Android avec une URL
 *    vide → intent invalide → WebView entre dans un état zombie + freeze.
 *  - `printWindow.document.write(...)` sur un null jette une TypeError non
 *    catchée → ErrorBoundary → écran blanc.
 *
 * Règle : avant tout `window.open()` ou `window.print()` natif, brancher
 * sur le print thermique via PrintService. En cas d'échec en APK, afficher
 * un toast plutôt que d'essayer un fallback navigateur.
 */
export function isNativeApp(): boolean {
  try {
    const Capacitor = (window as { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor;
    return !!Capacitor?.isNativePlatform?.();
  } catch {
    return false;
  }
}

/** True si on est en APK Android spécifiquement (utile pour features Android-only) */
export function isAndroidApp(): boolean {
  try {
    const Capacitor = (window as { Capacitor?: { getPlatform?: () => string } }).Capacitor;
    return Capacitor?.getPlatform?.() === 'android';
  } catch {
    return false;
  }
}
